export default __webpack_public_path__ + "static/media/7b.59c3a63d.svg";